export default {
  meta: {
    title: '拓店任务详情报表', // 拓店任务-标准版
  },
};
